import React, { Component } from 'react';
import {Link} from 'react-router';

export default class PageTitle extends Component {

    render() {
        return (
            <section className="page-title ptb-50">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>{this.props.title}</h2>
                            <ol className="breadcrumb">
                                <li><Link to={this.props.lastLink}>{this.props.last}</Link></li>
                                <li className="active">{this.props.title}</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/PageTitle.js